import { Component, HostListener, inject } from '@angular/core';
import { LucideAngularModule, AlertTriangle } from 'lucide-angular';
import { ConfirmationService } from '../../../core/services/confirmation.service';
import { ButtonComponent } from '../button/button.component';

/**
 * Host global del diálogo de confirmación. Se monta una vez en el root y pinta
 * lo que pida ConfirmationService. ESC o el backdrop cancelan.
 */
@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [LucideAngularModule, ButtonComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  private readonly confirmation = inject(ConfirmationService);
  readonly state = this.confirmation.state;
  readonly alertIcon = AlertTriangle;

  onConfirm(): void {
    this.confirmation.confirm();
  }

  onCancel(): void {
    this.confirmation.cancel();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.state()) this.confirmation.cancel();
  }
}
